var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-hypotheses-backdrop",
          attrs: { role: "presentation" },
          on: { click: _vm.onBackdropClick },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-hypotheses-modal",
              attrs: {
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "wkb-hypotheses-title",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("header", { staticClass: "wkb-hypotheses-head" }, [
                _c("div", { staticClass: "wkb-hypotheses-head-row" }, [
                  _c("h2", { attrs: { id: "wkb-hypotheses-title" } }, [
                    _vm._v("Build hypotheses"),
                  ]),
                  _c(
                    "button",
                    {
                      staticClass: "wkb-hypotheses-close",
                      attrs: {
                        type: "button",
                        "aria-label": "Close",
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" × ")]
                  ),
                ]),
                _c("p", { staticClass: "wkb-hypotheses-intro" }, [
                  _vm._v(
                    " Rank gene → mechanism → trait pathways among your selected nodes. Each result shows how those nodes connect — click Generate hypothesis for an LLM-written hypothesis, or open Association scores for evidence tables. "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "wkb-hypotheses-body" },
                [
                  !_vm.selectedNodeCount
                    ? _c("p", { staticClass: "wkb-hypotheses-empty" }, [
                        _vm._v(
                          " Mark nodes as selected on the canvas before building hypotheses. "
                        ),
                      ])
                    : [
                        _c("p", { staticClass: "wkb-hypotheses-helper" }, [
                          _vm._v(
                            " Using " +
                              _vm._s(_vm.selectedNodeCount) +
                              " selected node" +
                              _vm._s(_vm.selectedNodeCount === 1 ? "" : "s") +
                              " as the focus for connection ranking. "
                          ),
                        ]),
                        !_vm.llmAvailable
                          ? _c(
                              "p",
                              {
                                staticClass: "wkb-hypotheses-llm-note",
                                attrs: { role: "note" },
                              },
                              [
                                _vm._v(
                                  " LLM prioritization and hypotheses are not available — the interactive API did not report an LLM backend. "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.loading
                          ? _c(
                              "div",
                              {
                                staticClass: "wkb-hypotheses-loading",
                                attrs: { role: "status" },
                              },
                              [
                                _c("span", {
                                  staticClass: "wkb-hypotheses-spinner",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._m(0),
                              ]
                            )
                          : _vm._e(),
                        _vm.resultRun &&
                        _vm.resultRun.status === "success" &&
                        !_vm.draftRun
                          ? _c(
                              "section",
                              { staticClass: "wkb-hypotheses-results" },
                              [
                                _c("WorkspaceSigChainRunCard", {
                                  attrs: {
                                    run: _vm.resultRun,
                                    "anchor-items": _vm.anchorItems,
                                    "selected-node-ids": _vm.selectedNodeIds,
                                    "session-context": _vm.sessionContext,
                                    "api-client": _vm.apiClient,
                                    "llm-available": _vm.llmAvailable,
                                  },
                                  on: {
                                    "pathway-state-update": function ($event) {
                                      return _vm.$emit(
                                        "pathway-state-update",
                                        $event
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.draftRun
                          ? _c(
                              "section",
                              { staticClass: "wkb-hypotheses-form" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "wkb-hypotheses-label",
                                    attrs: { for: "wkb-hypotheses-query" },
                                  },
                                  [_vm._v(" Query sent to the LLM ")]
                                ),
                                _c("textarea", {
                                  staticClass: "wkb-hypotheses-textarea",
                                  attrs: {
                                    id: "wkb-hypotheses-query",
                                    rows: "5",
                                    placeholder:
                                      "Question for ranking gene → mechanism → trait connections",
                                    disabled: _vm.loading || !_vm.draftRun,
                                  },
                                  domProps: {
                                    value: _vm.draftRun.queryText || "",
                                  },
                                  on: { input: _vm.onQueryInput },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "wkb-hypotheses-label",
                                    attrs: { for: "wkb-hypotheses-context" },
                                  },
                                  [_vm._v(" Additional intent / context ")]
                                ),
                                _c("textarea", {
                                  staticClass: "wkb-hypotheses-textarea",
                                  attrs: {
                                    id: "wkb-hypotheses-context",
                                    rows: "3",
                                    placeholder:
                                      "Optional context or intent to add to the prompt",
                                    disabled: _vm.loading || !_vm.draftRun,
                                  },
                                  domProps: {
                                    value: _vm.draftRun
                                      ? _vm.draftRun.additionalContext
                                      : "",
                                  },
                                  on: { input: _vm.onContextInput },
                                }),
                                _c(
                                  "fieldset",
                                  {
                                    staticClass: "wkb-hypotheses-novelty",
                                    attrs: { disabled: _vm.loading },
                                  },
                                  [
                                    _c(
                                      "legend",
                                      {
                                        staticClass:
                                          "wkb-hypotheses-novelty-legend",
                                      },
                                      [_vm._v("Novelty filter")]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "wkb-hypotheses-novelty-intro",
                                      },
                                      [
                                        _vm._v(
                                          " Each node on your graph can carry a novelty label (see the Graph data table). Use this filter to prefer pathways built from more established versus more exploratory nodes. Ranking still prioritizes mechanistic coherence — novelty is a loose filter, not the main criterion. "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wkb-hypotheses-novelty-options",
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "wkb-hypotheses-novelty-option",
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: _vm.noveltyKnown,
                                              },
                                              on: {
                                                change:
                                                  _vm.onNoveltyKnownChange,
                                              },
                                            }),
                                            _vm._m(1),
                                          ]
                                        ),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "wkb-hypotheses-novelty-option",
                                          },
                                          [
                                            _c("input", {
                                              attrs: { type: "checkbox" },
                                              domProps: {
                                                checked: _vm.noveltyNovel,
                                              },
                                              on: {
                                                change:
                                                  _vm.onNoveltyNovelChange,
                                              },
                                            }),
                                            _vm._m(2),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "wkb-hypotheses-novelty-note",
                                      },
                                      [
                                        _vm._v(
                                          " Leave both unchecked to include any novelty label. Nodes marked NYA (not yet assessed) are included unless you restrict to Known or Novel only. "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm.draftRun?.promptPreview
                                  ? _c(
                                      "details",
                                      { staticClass: "wkb-hypotheses-prompt" },
                                      [
                                        _c("summary", [
                                          _vm._v("See prompt preview"),
                                        ]),
                                        _c(
                                          "pre",
                                          {
                                            staticClass:
                                              "wkb-hypotheses-prompt-pre",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.draftRun.promptPreview)
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.draftRun?.status === "error"
                          ? _c(
                              "div",
                              {
                                staticClass: "wkb-hypotheses-error",
                                attrs: { role: "alert" },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.draftRun.error ||
                                        "Could not rank connections."
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                ],
                2
              ),
              _vm.selectedNodeCount &&
              (_vm.draftRun || _vm.resultRun) &&
              !_vm.loading
                ? _c("div", { staticClass: "wkb-hypotheses-actions" }, [
                    _vm.resultRun && !_vm.draftRun
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wkb-hypotheses-btn wkb-hypotheses-btn-secondary",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("new-run")
                              },
                            },
                          },
                          [_vm._v(" Find connections again ")]
                        )
                      : _vm._e(),
                    _vm.draftRun
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "wkb-hypotheses-btn wkb-hypotheses-btn-primary",
                            attrs: { type: "button", disabled: !_vm.canRun },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("run")
                              },
                            },
                          },
                          [_vm._v(" Find connections ")]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("strong", [_vm._v("Finding connections…")]),
      _c("p", [_vm._v("This may take a moment.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "wkb-hypotheses-novelty-option-text" }, [
      _c("strong", [_vm._v("Known")]),
      _c("span", { staticClass: "wkb-hypotheses-novelty-option-desc" }, [
        _vm._v(
          " Prefer pathways whose nodes are judged well-supported or already mapped in the literature for your session context. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "wkb-hypotheses-novelty-option-text" }, [
      _c("strong", [_vm._v("Novel")]),
      _c("span", { staticClass: "wkb-hypotheses-novelty-option-desc" }, [
        _vm._v(
          " Prefer pathways with less-established or more speculative connections that may be impactful but are not yet widely documented. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }